import { MarketSelectorStoreModuleFactory } from "@fds/wm-typescript-poc-waap-stores-mdg2";
import type { MarketSelectorInputsInterface } from "@fds/wm-typescript-poc-waap-library";
import type { IdNotationType } from "@fds/wm-typescript-poc-waap-stores-mdg2/src/interfaces";
import type { InstrumentNotationListResult } from "@fds/wm-typescript-poc-waap-stores-mdg2/src/endpoints";

export class EgbMarketSelectorStoreModuleFactory extends MarketSelectorStoreModuleFactory {
  private intervalId: any = null;

  protected getAvailableMarkets(
    payload: MarketSelectorInputsInterface<IdNotationType>
  ): InstrumentNotationListResult["data"][0]["notations"] | undefined {
    const assetClass = this.getAssetClass(payload);
    const instrumentNotationListData =
      this.getInstrumentNotationListData(payload);
    let markets = instrumentNotationListData?.[0].notations.filter(
      ({ market }) => this.isMarketQualified(market, assetClass)
    );

    const specificMarketIDs = [1126, 1120];
    const marketIDs = markets?.map(({ market }) => market.id) ?? [];
    if (
      specificMarketIDs.every((id) => marketIDs.includes(id)) &&
      marketIDs.length === specificMarketIDs.length
    ) {
      markets = markets?.filter(({ market }) => market.id !== 1126);
    }

    return markets;
  }

  public async updateComponentsInputs(
    payload: MarketSelectorInputsInterface<IdNotationType>
  ): Promise<boolean> {
    let status = true;

    try {
      await this.updateInstrumentNotationList(payload);
    } catch (e) {
      this.logger.error(e);
      status = false;
    }

    this.searchAndFilterSelectElements();

    return Promise.resolve(status);
  }

  private searchAndFilterSelectElements() {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }

    let searchCompleted = false;

    const searchForSelects = () => {
      const selectElements = document.querySelectorAll<HTMLSelectElement>(
        '[id^="fds-market-selector-"]'
      );
      const filteredSelects = Array.from(selectElements).filter((select) =>
        Array.from(select.options).some((option) =>
          option.label.includes("Erste Group")
        )
      );

      if (filteredSelects.length === 1) {
        clearInterval(this.intervalId);
        this.intervalId = null;
        searchCompleted = true;
        Array.from(filteredSelects[0].options).forEach((option) => {
          if (option.label.includes("Erste Group") && !option.selected) {
            option.selected = true;
            const event = new Event("change", { bubbles: true });
            filteredSelects[0].dispatchEvent(event);
          }
        });
      }
    };

    this.intervalId = setInterval(searchForSelects, 150);

    setTimeout(() => {
      if (!searchCompleted) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }, 10000);
  }
}
